export const maxInteractions = 5